"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnableAbilityEffectHandler = exports.EnableAbilityEffectArgs = void 0;
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class EnableAbilityEffectArgs {
    constructor(slot) {
        this.slot = slot;
        this.__type = EffectType_1.EffectType.EnableAbility;
        this.__typeName = "EnableAbility";
        this.name = "Enable Ability";
        this.harmful = false;
    }
}
exports.EnableAbilityEffectArgs = EnableAbilityEffectArgs;
let EnableAbilityEffectHandler = class EnableAbilityEffectHandler {
    apply(sequence, container, state) {
        container.enableAbility(sequence, state.targetId, state.args.slot);
    }
    remove(sequence, container, state) {
        container.disableAbility(sequence, state.targetId, state.args.slot);
    }
};
EnableAbilityEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.EnableAbility)
], EnableAbilityEffectHandler);
exports.EnableAbilityEffectHandler = EnableAbilityEffectHandler;
